import { render, staticRenderFns } from "./TabContentContacts.vue?vue&type=template&id=3d3703b4"
import script from "./TabContentContacts.vue?vue&type=script&lang=js"
export * from "./TabContentContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports